module.exports = __webpack_public_path__ + "img/2200-1_YR_2022_Ransomware.d70f1743.png";